// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout-Footer_header_1eLzw","wrapper":"Layout-Footer_wrapper_23C8p structure_pageContainer_3AHT8 typography_standard_3NYy8"};